'use client';
import React from 'react';
import { ScreenerResultsGrid, type ScreenerResultColumn } from '@benzinga/screener-widget';
import { ContentFeed } from '@benzinga/news';
import type { StoryObject } from '@benzinga/advanced-news-manager';
import { getScreenerFeedTickers, SCREENER_FEED_PAGE_SIZE } from '@benzinga/blocks-utils';
import { usePermission } from '@benzinga/user-context';

interface ScreenerBlockProps {
  instruments?: Array<Record<string, unknown>>;
  feedNodes?: StoryObject[];
  enable_newsfeed?: boolean;
  newsfeed_title?: string | null;
  query_data?: {
    columns?: ScreenerResultColumn[];
    fields?: string[];
    limit?: number;
    link?: string | { url?: string } | null;
  };
}

export const ScreenerBlock: React.FC<ScreenerBlockProps> = ({
  enable_newsfeed = false,
  feedNodes,
  instruments = [],
  newsfeed_title,
  query_data,
}) => {
  const hasEdge = usePermission('com/read', 'unlimited-calendars');
  const rawLink = query_data?.link;
  const edgeMaskLink = (typeof rawLink === 'string' ? rawLink : rawLink?.url) || undefined;
  const tickers = React.useMemo(
    () => (enable_newsfeed ? getScreenerFeedTickers(instruments) : []),
    [enable_newsfeed, instruments],
  );

  return (
    <>
      <ScreenerResultsGrid
        columns={query_data?.columns}
        edgeMaskLink={edgeMaskLink}
        fields={query_data?.fields}
        hasEdge={hasEdge}
        instruments={instruments}
        pageSize={10}
      />
      {tickers.length > 0 && (
        <div className="mt-8">
          <ContentFeed
            limit={SCREENER_FEED_PAGE_SIZE}
            loadMore
            nodes={feedNodes}
            query={{ tickers }}
            title={newsfeed_title || undefined}
          />
        </div>
      )}
    </>
  );
};
